module.exports = __webpack_public_path__ + "img/collection-engagementRingsRosegold.c59b470.jpg";